import { createActions } from 'reduxsauce'

export const { Types, Creators } = createActions({
  firebaseListenRequested: ['ref', 'metaType'],
  firebaseListenRejected: ['error', 'metaType'],
  firebaseListenFulfilled: ['items', 'metaType'],
  firebaseListenChildUpdated: ['id', 'value', 'metaType'],
  firebaseListenRemoved: ['clearItems', 'metaType'],
  firebaseRemoveListenerRequested: ['clearItems', 'metaType'],
})
